/**
 * Created by mark on 6/27/2019.
 */
import Service from "../../../Services/index";

const TaxInvoice = {
    namespaced: true,
    state: {
        TaxInvoiceList: [],
        form_tax : {
            id : '',
            customer : '',
            type : '3',
            tax : []
        },
        tax : {
            index : '',
            date : '',
            amount : '',
            tax_type : '',
            tax : '',
        },
        form : {
            id : '',
            invoice_id : '',
            date : '',
            tax_invoice : '',
            total : '',
            tax : '',
            invoice : '',
        },
        select_all : false,
        search:{
            tax_number: "",
            invoice: '',
            customer : null,
            date : [],
            type_tax : 'all',
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        tax_customer_list : [],
        tax_customer_info_list : [],
        pagination: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        GET_TAX_INVOICE:(state,res)=>{
            state.TaxInvoiceList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_FORM_TAX_INVOICE:(state,res)=>{
          state.form = res;
        },
        CLEAR_SEARCH : state=>{
            state.search = {
                tax_number: "",
                invoice: '',
                customer : null,
                date : [],
                type_tax : 'all',
            }
        },
        SET_SELECT_ALL:(state,res)=>{
            state.select_all = res;
        },
        SET_CUSTOMER_TAX:(state,res)=>{
            state.form_tax.tax = [];
            res.forEach(()=>{
                state.form_tax.tax.push({ ...state.tax })
            })
        },
        SET_CUSTOMER_TAX_LIST:(state,res)=>{
            state.tax_customer_list = res.data;
            state.pagination = {
                current_page: res.current_page,
                last_page: res.pages,
                per_page: 10,
                from: 1,
                to: res.pages,
                total: res.total
            };
        },
        SET_CUSTOMER_INFO_TAX_LIST:(state,res)=>{
            state.tax_customer_info_list = res.data.data;
            state.pagination = {
                current_page: res.data.current_page,
                last_page: res.data.last_page,
                per_page: res.data.per_page,
                from: res.data.from,
                to: res.data.to,
                total: res.data.total
            };
        },
        CLEAR_CUSTOMER_TAX:(state)=>{
            state.form_tax = {
                id : '',
                customer : '',
                type : '3',
                tax : []
            }
        },

    },
    actions: {
        setTaxInvoice({commit}, page = 1) {
            return Service.TaxInvoice.getTaxInvoice(page).then(res => {
                commit("GET_TAX_INVOICE", res);
            });
        },
        saveTaxInvoice({commit},{id,data,user = null}){
            if(!id){
                return Service.TaxInvoice.createTaxInvoice(data,user);
            }
            else{
                return Service.TaxInvoice.updateTaxInvoice(id,data,user);
            }
        },
        showTaxInvoice({commit},id){
          return Service.TaxInvoice.showTaxInvoice(id).then(res=>{
              commit('SET_FORM_TAX_INVOICE',res);
          });
        },
        deleteTaxInvoice({commit},id){
          return Service.TaxInvoice.deleteTaxInvoice(id);
        },
        search({commit},{page=1,data}){
            return Service.TaxInvoice.searchTaxInvoice(page,data).then(res=>{
                if(res.current_page){
                    commit("GET_TAX_INVOICE",res)
                }
                return res;
            })
        },
        selectTaxInvoiceAll({commit}){
            return Service.TaxInvoice.selectTaxInvoiceAll();
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        getInvoiceByStatusTax({commit}){
            return Service.TaxInvoice.getInvoiceByStatusTax();
        },
        printMultiTax({commit},id){
            return Service.TaxInvoice.printMultipleTax(id);
        },
        setSelectAll({commit},data){
            commit('SET_SELECT_ALL',data)
        },
        getTaxList({commit}) {
            return Service.TaxInvoice.getTaxList().then(res => {
                commit('SET_CUSTOMER_TAX',res);
                return res;
            });
        },
        getCustomerTaxList({commit}) {
            return Service.TaxInvoice.getCustomerTaxList()
        },
        clearTaxForm({commit}) {
            commit('CLEAR_CUSTOMER_TAX');
        },
        createTaxCustomer({commit},data) {
            return Service.TaxInvoice.createTaxCustomer(data)
        },
        showTaxCustomer({commit},id) {
            return Service.TaxInvoice.showTaxCustomer(id)
        },
        showTaxList({commit},data) {
            return Service.TaxInvoice.showTaxList(data)
        },
        saveTaxCustomer({commit},data) {
            return Service.TaxInvoice.saveTaxCustomer(data)
        },
        getTaxCustomer({commit},data) {
            return Service.TaxInvoice.getTaxCustomer(data).then(res=>{
                commit('SET_CUSTOMER_TAX_LIST',res);
            })
        },
        getTaxCustomerInfo({commit},data) {
            return Service.TaxInvoice.getTaxCustomerInfo(data).then(res=>{
                commit('SET_CUSTOMER_INFO_TAX_LIST',res);
            })
        },
        closeTaxInvoice({commit},date) {
            return Service.TaxInvoice.closeTaxInvoice(date)
        },
        chageAddressTaxInvoice({commit},data) {
            return Service.TaxInvoice.chageAddressTaxInvoice(data)
        }
    }
};

export default TaxInvoice;
